module.exports = __webpack_public_path__ + "img/signup.a4b01fd1.jpg";